import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { getGeoParams } from 'utils/parameters'
import { actionCreators as geoPickerActionCreators } from 'reduxBits/geoPicker'

import { buildGeoSearchParams } from 'utils/geo'

const mapStateToProps = (state) => ({
  byQueryKey: state.searchParams.byQueryKey,
  geoPreference: state.geoPicker.geoPreference || {},
})

const mapDispatchToProps = (dispatch) => ({
  geoPickerActions: bindActionCreators(geoPickerActionCreators, dispatch),
})

const GeoPicker = ({ byQueryKey, geoPickerActions, onChange, Component, ...rest }) => {
  const handleChange = (newGeoPreference) => {
    geoPickerActions.setGeoPreference(getGeoParams(newGeoPreference))
    const newSearchParams = buildGeoSearchParams(newGeoPreference)
    onChange(newSearchParams)
  }

  return <Component regionParameter={byQueryKey.r} onChange={handleChange} {...rest} />
}

GeoPicker.propTypes = {
  byQueryKey: PropTypes.object.isRequired,
  geoPickerActions: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  geoPreference: PropTypes.object.isRequired,
  Component: PropTypes.any,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(GeoPicker),
)
